import React, { useEffect, useContext, useState } from "react";
import { useForm } from "react-hook-form";
import "./Footer.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { NavLink, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Common_Button from "../Common-Component/Common_Button/Common_Button";
import classNames from "classnames";
import { Context } from "../../utils/context";
import { AppSetup } from "../../utils/apis/common/Common";
import Successfull_Modal from "../Common_modal/Successfull_Modal/Successfull_Modal";
import Newly_launch from "../Common_modal/newly_launch/Newly_launch";
import { faClockFour } from "@fortawesome/free-solid-svg-icons";
const Footer = () => {
  const [modalShow, setModalShow] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const { IMG_URL, postData } = useContext(Context);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [emailerror, setemailErrors] = useState("");

  const onSubmit = async (d) => {
    const res = await postData(`/without-login/info-subscribe`, d);
    if (res?.success) {
      reset();
      setSuccessful(true);
      setTimeout(() => {
        setSuccessful(false);
        window.scrollTo(0, 0);
      }, 3000);
    } else {
      setemailErrors(res?.message);
    }
  };

  const [setups, setSetup] = useState();
  const getSetup = async () => {
    const res = await AppSetup();
    if (res?.success) {
      setSetup(res?.data);
    }
  };

  useEffect(() => {
    getSetup();
  }, []);

  return (
    <>
      <section className="footer">
        <Container fluid>

          <div className="row">
            <div className="col-xl-11 mx-auto">
              <div className="row">

                <div className="col-lg-3  ">
                  <Link as={Link} to="/">
                    <img
                      className="headlogo"
                      // src={IMG_URL + setups?.image}
                      src={process.env.PUBLIC_URL + '/assets/Image/Logo/logo-footer.png'}
                      alt="Logo"
                    />
                  </Link>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6 ">
                  <div className="row location-holder">
                    <div className="col-sm-12">
                      <h3 className="footerhead">Quick Links</h3>
                      <div className="call-holder me-4">
                        <Link to={"/"}>
                          <span className="me-2">Home</span>
                        </Link>
                      </div>

                      <div className="call-holder me-4">
                        <Link
                          to={"/about-us"}
                        >
                          <span className="me-2">About us</span>
                        </Link>
                      </div>

                      {/* <div className="call-holder me-4">
                        <Link
                          to={"/sale-products"}
                        >
                          <span className="me-2">Sale </span>
                        </Link>
                      </div> */}

                      <div className="call-holder me-4">
                        <Link
                          to={"/contact-us"}
                        >
                          <span className="me-2">Contact us</span>
                        </Link>
                      </div>


                      <div className="call-holder me-4">
                        <Link
                          to={"/faq"}
                        >
                          <span className="me-2">FAQ</span>
                        </Link>
                      </div>

                      <div className="call-holder me-4">
                        <Link
                          to={"/exchange-cancellation-policy"}
                        >
                          <span className="me-2">Exchange & Cancellation Policy</span>
                        </Link>
                      </div>

                      <div className="call-holder me-4">
                        <Link
                          to={"/terms-conditions"}
                        >
                          <span className="me-2">Terms & Conditions</span>
                        </Link>
                      </div>

                      <div className="call-holder me4">
                        <Link
                          to={"/privacy-policy"}
                        >
                          <span className="me-2">Privacy Policy</span>
                        </Link>
                      </div>


                      <div className="call-holder me4">
                        <Link
                          to={"/shipping-policy"}
                        >
                          <span className="me-2">Shipping Policy</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-6  helpdeskposs">
                  <div className="location-holder  ">
                    <div className="address-holder">
                      <div className="text-holder">
                        <h3 className="footerhead">Help Desk/Inquiry</h3>
                      </div>
                      <div className="call-holder me-4">
                        <FontAwesomeIcon
                          icon="fa-solid fa-phone"
                          className="call-icon me-2"
                        />
                        <span className="me-2">{setups?.contact_no} </span>
                      </div>

                      <div className="text-holder mt-4">
                        <h3 className="footerhead">Return Exchange</h3>
                      </div>

                      <div className="call-holder ">
                        <a
                          target="_blank"
                          class="webwhats"
                          href={`https://web.whatsapp.com/send?phone=${setups?.return_exchange}`}
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/Icon/whatsapp-icon.png"
                            }
                            className="whatssiccc me-2"
                          />
                          <span>+91 {setups?.return_exchange}</span>
                        </a>

                        <a
                          target="_blank"
                          class="mobwhats"
                          href="https://wa.me/7720080399"
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/Icon/whatsapp-icon.png"
                            }
                            className="whatssiccc me-2"
                          />
                          <span>+91 7720080399</span>
                        </a>
                      </div>

                      <div className="text-holder mt-4">
                        <h3 className="footerhead">Complain Assistance</h3>
                      </div>

                      <div className="call-holder ">
                        <span>+91 {setups?.complain_assistance}</span>
                      </div>

                      <div className="call-holder me-4">
                        <FontAwesomeIcon
                          icon="fa-solid fa-envelope"
                          className="call-icon me-2"
                        />
                        <span className="me-2">{setups?.email}</span>
                      </div>


                    </div>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12  ">

                  <div className="text-area-loaction location-holder">
                    <h3 className="footerhead">Address</h3>
                    <p><FontAwesomeIcon icon="fa-solid fa-location-dot" />{" "}
                      {setups?.address}
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="row copyright-holder">
            <div className="col-md-11 mx-auto">
              <div className="row">
                <div className="col-lg-4 pt-2">
                  <div className="soccicooo-flex my-auto">
                    <div className="text-holder my-auto">
                      <h3 className="footerhead my-auto">Follow Us On :</h3>
                    </div>

                    <div className="ico-div  my-auto">
                      <Link
                        to={
                          "https://www.facebook.com"
                        }
                        target="_blank"
                      >
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/footer/facebook.png"
                            }
                            className="socialIcon"
                          />
                        </div>
                      </Link>

                      <Link
                        to={
                          "https://www.instagram.com"
                        }
                        target="_blank"
                      >
                        <div>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/footer/insta.png"
                            }
                            className="socialIcon"
                          />
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 text-lg-center order-md-1 order-2">
                  <p>
                    ©2026 Indieaura Ethnic. All Rights Reserved.{" "}
                    <Link to="https://profcymaglobal.com/" target="___blank">
                      Developed by Profcyma Solutions Pvt Ltd
                    </Link>
                  </p>
                </div>

                <div className="col-lg-4  order-md-2 order-1">
                  <div className="footerbottom">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>

        <Newly_launch
          show={modalShow}
          onHide={() => setModalShow(false)}
          setModalShow={setModalShow}
          modalShow={modalShow}
        />
      </section>
      <Successfull_Modal
        message={`Successfully Subscribed`}
        show={successful}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Footer;
